import React, { useEffect, useState, useRef } from 'react';
import Header from '../../components/header';
import Layout from '../../components/layout';
import { AgGridReact } from 'ag-grid-react';
import { AllCommunityModule, ModuleRegistry } from "ag-grid-community";
import toast from 'react-hot-toast';
import { PAGE_SIZE } from '../../_common/constant';
import Pagination from '../../components/pagination';
import Search from '../../components/search';
import Loader from '../../components/loader';
import Button from '../../components/elements/button';
import Drawer from '../../components/Drawer';
import Filters from '../../components/filters';
import { filterConfigType } from '../../_config/types';
import Icon from '../../components/icons';
import { titleCell } from '../../components/elements/function';
import { useDialog } from '../../store/api/hooks/dialogHook';
import { showLocalDateTime } from '../../_common/functions';
import { useParams } from 'react-router-dom';
import { useUserApi } from '../../store/api/hooks/userApiHook';
import CreatePermission from './_components/createpermission';
import { useCommonApi } from '../../store/api/hooks/commonApiHook';

ModuleRegistry.registerModules([AllCommunityModule]);

const UserTypePermission: React.FC = () => {
    const userApi = useUserApi();
    const commonApi = useCommonApi();

    const [currentPage, setCurrentPage] = useState<number>(1);
    const [searchParam, setSearchParam] = useState<string>('');
    const [totalRecords, setTotalRecords] = useState<number>(0);
    const [rowData, setRowData] = useState<any>(null);
    const [userTypeName, setUserTypeName] = useState<string>('');
    const [gridApi, setGridApi] = useState<any>(null);
    const [gridColumnApi, setGridColumnApi] = useState<any>(null);
    const [loadingRowId, setLoadingRowId] = useState<string | null>(null);
    const [filtersApplied, setFiltersApplied] = useState<any>({ generalFilter: false, locationFilter: false });
    const [facilityOption, setFacilityOption] = useState<any>([]);
    const [filters, setFilters] = useState<any>({});
    const [editData, setEditData] = useState<any>(null);
    const [selectedUserModuleID, setSelectedUserModuleID] = useState<any>(null);
    const params: any = useParams();

    const filtersRef: any = useRef();
    const createPermissionRef: any = useRef();
    const { confirm } = useDialog();

    const filterConfig: filterConfigType[] = [
        { name: 'Name', type: 'text', key: 'name' },
        { name: 'URL', type: 'text', key: 'url' },
        { name: 'API', type: 'text', key: 'api' },
        { name: 'Entities', type: 'text', key: 'entities' },
    ]

    const columnDefs = [
        {
            headerName: 'Name',
            field: 'name',
            headerClass: 'bg-[#f0f0f0]',
            minWidth: 200, flex: 1,
            cellRenderer: titleCell
        },
        {
            headerName: 'URL',
            field: 'url',
            headerClass: 'bg-[#f0f0f0]',
            minWidth: 200, flex: 1,
            cellRenderer: (params: any) => {
                return (
                    <p className='hover:text-primary'>
                        {params.value || '-'}
                    </p>
                );
            }
        },        
        {
            headerName: 'Action',
            field: 'action',
            headerClass: 'bg-[#f0f0f0] text-center',
            pinned: 'right',
            width: 90,
            cellRenderer: (params: any) => {
                return (
                    <div className='relative h-full w-full flex items-center justify-center'>
                        <div>
                            <Icon name='threedote' size={1.25} className='text-[#000000]' onClick={(e: any) => {
                                e.stopPropagation();
                                e.preventDefault();
                                const dropdown: any = document.querySelector('.action-dropdown');
                                if (dropdown) {
                                    dropdown.focus();
                                }
                                return false;
                            }} />
                            <select
                                onChange={(e) => {
                                    handleActionChange(e, params);
                                    e.target.selectedIndex = -1;
                                }}
                                onFocus={(e) => {
                                    e.target.selectedIndex = -1;
                                }
                                }
                                className="action-dropdown"
                                style={{
                                    position: "absolute",
                                    top: 0,
                                    left: 0,
                                    width: "100%",
                                    height: "100%",
                                    opacity: 0,
                                    cursor: "pointer",
                                }}
                            >
                                <option value="edit">Edit</option>
                                <option value="delete">Delete</option>
                                {/* <option value="view">View</option> */}
                            </select>
                        </div>
                    </div>
                )
            }
        },
    ];

    const handleActionChange = (e: any, params: any) => {
        const action = e.target.value;
        const rowData = params.data;
        switch (action) {
            case "edit":
                setEditData(rowData);
                setSelectedUserModuleID(rowData.userModuleID);
                createPermissionRef.current.open();
                console.log("Edit action for row: ", rowData);
                break;
            case "delete":
                // Implement delete action
                confirm({
                    type: 'delete',
                    title: 'Delete Permission',
                    message: 'Are you sure you want to delete this permission?',
                    onConfirm: () => {
                        userApi.deleteUserModule({ userTypeID: rowData.userTypeID,
                            name: rowData.name, deleteModule: true
                         }, (data: any, msg: any) => {
                            toast.success(msg);
                            getUserTypePermissions();
                        }, (error: any) => {
                            toast.error(error);
                        });
                    }
                });
                break;
            default:
                console.log("Unknown action: ", action);
        }
        e.target.selectedIndex = -1;
    };

    const getUserTypePermissions = () => {
        const payload: any = {
            pageSize: 30,
            userTypeID: params.id,
            pageNumber: currentPage,
            searchParam: searchParam,
            isTemplate: true
        };
        if (filters) {
            Object.keys(filters).forEach((key: any) => {
                if (filters[key]) payload[key] = filters[key];
            });
        }

        // Uncomment and implement actual API call as needed

        userApi.getUserModules(
            payload,
            (resp: any) => {
                console.log('User Modules Response:', resp);
                setRowData(resp.userModules ? resp.userModules : []);
                if (resp?.userModules && resp.userModules.length > 0) {
                    setTotalRecords(resp.userModules[0].totalRecord);
                }
            },
            (error: any) => {
                toast.error(error);
            }
        );

    };

    const getUserTypes = () => {
        const payload: any = { userTypeID: params.id };
        setRowData(null);
        userApi.getUserTypes(payload, (resp: any) => {
            setUserTypeName(resp.userTypeList[0].name);
        }, (error: any) => {
            toast.error(error);
        });
    };

    const onGridReady = (params: any) => {
        setGridApi(params.api);
        setGridColumnApi(params.columnApi);
    };

    const getSelectedRows = () => {
        const selectedNodes = gridApi?.getSelectedNodes();
        return selectedNodes.map((node: any) => node.data);
    };

    const onRowClicked = (event: any) => {
        if (!event.event.target.closest('input[type="checkbox"]')) {
            event.node.setSelected(false);
        }
    };

    useEffect(() => {
        getUserTypes();
        getUserTypePermissions();
    }, [currentPage, searchParam, filters]);

    return (
        <Layout>
            <Header title={`User Type Permission - ${userTypeName}`} back="/users/settings">
                <Header.Right>
                    <Drawer isAfterOpenRender={true} _ref={createPermissionRef} onClose={() => { 
                        setEditData(null); 
                        setSelectedUserModuleID(null);
                    }}>
                        <Drawer.Button>
                            <Button>New Permission</Button>
                        </Drawer.Button>
                        <Drawer.Content title={editData ? 'Edit Permission' : 'New Permission'} className='!w-[39rem]'>
                            <CreatePermission
                                userModuleID={selectedUserModuleID}
                                userTypeID={params.id}
                                onCreate={() => {
                                    createPermissionRef.current.close();
                                    //setSelectedUserModuleID(null);
                                    getUserTypePermissions();
                                }}
                                onCancel={() => {
                                    //setSelectedUserModuleID(null);
                                    createPermissionRef.current.close();                                    
                                }}
                            />
                        </Drawer.Content>
                    </Drawer>
                </Header.Right>
            </Header>

            <div className='flex items-center justify-between pl-5 pr-3 border-b border-gray-200 h-[3.75rem]'>
                <Pagination
                    perPage={30}
                    totalRecords={totalRecords}
                    onPageChange={setCurrentPage}
                    currentPage={currentPage}
                />
                {/* <Search onSearch={setSearchParam} /> */}
            </div>

            <div className='bg-[#FAFAFA]'>
                <div className='hidden gap-4 px-5 py-2 items-center '>
                    <Button theme='light' onClick={() => filtersRef.current.showModal()}>
                        Filter <Icon name='filter' size={1.40} className={filtersApplied.generalFilter ? "text-blue-700" : ""} />
                    </Button>
                    <p className='text-primary font-semibold text-sm cursor-pointer' onClick={() => {
                        setFilters({});
                        setFiltersApplied({ generalFilter: false, locationFilter: false });
                        setCurrentPage(1);
                    }}>
                        Clear Filters
                    </p>
                </div>

                <div className="ag-theme-alpine mx-4 h-1/2 mt-3">
                    <AgGridReact
                        columnDefs={columnDefs as any}
                        rowData={rowData}
                        pagination={false}
                        rowSelection="multiple"
                        onGridReady={onGridReady}
                        domLayout="autoHeight"
                        onRowClicked={onRowClicked}
                        loadingOverlayComponent={Loader}
                        noRowsOverlayComponent={() => (
                            <div style={{ padding: '2rem', textAlign: 'center', color: '#888' }}>
                                No permission added yet!
                            </div>
                        )}
                    />
                </div>
            </div>
            <Filters _ref={filtersRef} config={filterConfig} filters={filters} onUpdate={setFilters} />
        </Layout>
    );
};

export default UserTypePermission;
